import { useEffect, useState } from "react";

export default function useHasActiveFilters() {
  const [hasActiveFilters, setHasActiveFilters] = useState(false);

  const getActiveFilters = () => {
    const activeFilters = window?.fnReactBus?.filtersPanel?.filters;

    if (!activeFilters) {
      setTimeout(() => getActiveFilters(), 100);
      return;
    }

    setHasActiveFilters(activeFilters.length > 0);
  };

  useEffect(getActiveFilters, [getActiveFilters]);

  return [hasActiveFilters, setHasActiveFilters];
}
